import { t as __exportAll } from "./chunk-pbuEa-1d.js";
import { n as ok, t as err } from "./result-D_NYcfr2.js";
import { attemptAsync } from "es-toolkit";
import * as fsNative from "node:fs/promises";
//#region src/node/fs.ts
var fs_exports = /* @__PURE__ */ __exportAll({
	exists: () => exists,
	list: () => list,
	mkdir: () => mkdir,
	read: () => read,
	remove: () => remove,
	write: () => write
});
/**
* Check whether a path exists and is accessible.
*
* Wraps `fs.access` into a boolean check — never throws.
*
* @param path - The absolute path to check.
* @returns True when the path exists and is accessible.
*/
async function exists(path) {
	const [error] = await attemptAsync(() => fsNative.access(path));
	return error === null;
}
/**
* Read a file's contents as a UTF-8 string.
*
* @param path - The absolute file path to read.
* @returns A result tuple with the file contents or an Error.
*/
async function read(path) {
	const [error, contents] = await attemptAsync(() => fsNative.readFile(path, "utf8"));
	if (error || contents === null) return err(new Error(`failed to read ${path}`, { cause: error }));
	return ok(contents);
}
/**
* Write a UTF-8 string to a file.
*
* @param path - The absolute file path to write.
* @param content - The string content to write.
* @returns A result tuple with void on success or an Error.
*/
async function write(path, content) {
	const [error] = await attemptAsync(() => fsNative.writeFile(path, content, "utf8"));
	if (error) return err(new Error(`failed to write ${path}`, { cause: error }));
	return ok();
}
/**
* List filenames in a directory.
*
* @param path - The absolute directory path to list.
* @returns A result tuple with filenames or an Error.
*/
async function list(path) {
	const [error, entries] = await attemptAsync(() => fsNative.readdir(path));
	if (error || entries === null) return err(new Error(`failed to list ${path}`, { cause: error }));
	return ok(entries);
}
/**
* Create a directory, including parent directories.
*
* @param path - The absolute directory path to create.
* @returns A result tuple with void on success or an Error.
*/
async function mkdir(path) {
	const [error] = await attemptAsync(() => fsNative.mkdir(path, { recursive: true }));
	if (error) return err(new Error(`failed to create directory ${path}`, { cause: error }));
	return ok();
}
/**
* Remove a file or directory. Silently succeeds if the path does not exist.
*
* @param path - The absolute path to remove.
* @returns A result tuple with void on success or an Error.
*/
async function remove(path) {
	const [error] = await attemptAsync(() => fsNative.rm(path, {
		recursive: true,
		force: true
	}));
	if (error) return err(new Error(`failed to remove ${path}`, { cause: error }));
	return ok();
}
//#endregion
export { remove as a, read as i, fs_exports as n, write as o, list as r, exists as t };

//# sourceMappingURL=fs-6FuEguuO.js.map